'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var Viewport = require('cf-component-viewport');
var Select = require('cf-component-select');

var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.getChildContext = function getChildContext() {
    return {
      activeTab: this.props.activeTab
    };
  };

  Tabs.prototype.handleChange = function handleChange(id) {
    if (id !== this.props.active) {
      this.props.onChange(id);
    }
  };

  Tabs.prototype.handleKeyDown = function handleKeyDown(id, event) {
    if (event.which === 13) {
      this.handleChange(id);
    }
  };

  Tabs.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'section',
      { className: 'cf-tabs' },
      React.createElement(
        Viewport,
        { size: 'mobile' },
        React.createElement(Select, {
          onChange: this.handleChange,
          value: this.props.activeTab,
          options: this.props.tabs.map(function (tab) {
            return {
              value: tab.id,
              label: tab.label
            };
          }) })
      ),
      React.createElement(
        Viewport,
        { not: true, size: 'mobile' },
        React.createElement(
          'ul',
          { className: 'cf-tabs__group', role: 'tablist' },
          this.props.tabs.map(function (tab) {
            var selected = tab.id === _this2.props.activeTab;

            var className = 'cf-tabs__item';
            if (selected) {
              className += ' cf-tabs__item--active';
            }

            return React.createElement(
              'li',
              { key: tab.id,
                role: 'tab',
                tabIndex: 0,
                'aria-controls': tab.id,
                'aria-selected': selected,
                className: className,
                onKeyDown: _this2.handleKeyDown.bind(_this2, tab.id),
                onClick: _this2.handleChange.bind(_this2, tab.id) },
              tab.label
            );
          })
        )
      ),
      this.props.children
    );
  };

  return Tabs;
}(React.Component);

Tabs.propTypes = {
  onChange: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
};
Tabs.childContextTypes = {
  activeTab: PropTypes.string.isRequired
};


module.exports = Tabs;